'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = require('../events');

var isExpired = function isExpired(token) {
  try {
    var tokenPayload = token.substring(token.indexOf('.') + 1, token.indexOf('.', token.indexOf('.') + 1));

    var decodedPayload = JSON.parse(atob(tokenPayload));

    if (decodedPayload.exp < new Date().getTime() / 1000) {
      return true;
    }
  } catch (error) {
    // Swallow any JSON or base64 decoding errors
    return false;
  }

  return false;
};

exports.default = {
  onStart: function onStart(request) {
    var jwtToken = this.client.getJwtToken();
    if (jwtToken) {
      request.headers.append('Authorization', jwtToken);
    }
    return request;
  },
  onFail: function onFail(request, response) {
    if (response.status === 401) {
      if (isExpired(this.client.getJwtToken())) {
        this.client.eventEmitter.emit(_events.AUTH_EXPIRED, request, response);
      } else {
        this.client.eventEmitter.emit(_events.AUTH_FAILED, request, response);
      }
    }
    return response;
  },


  helpers: {
    setJwtTokenGetter: function setJwtTokenGetter(func) {
      this.getJwtToken = func;
    },
    getJwtToken: function getJwtToken() {
      throw new Error('You must define getJwtToken with client.helpers.setJwtTokenGetter');
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@synapsestudios/fetch-client/lib/plugins/jwt.js
// module id = 738
// module chunks = 0